<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-mt-2">
                <DataTable v-model:expandedRows="expandedRows" v-model:selection="selectedRows" :value="menus"
                    dataKey="key" :lazy="true" :paginator="false" :totalRecords="totalRecords" :loading="loading"
                    @page="onPage($event)" class="p-datatable-users" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown">
                    <Toolbar>
                        <template v-slot:left>
                            <h5 class="p-m-0">Menus and Sub-menus</h5>
                        </template>
                        <template v-slot:right>
                            <div v-if="selectedRows.length > 0">
                                <Dropdown id="submenustatus" style="width: 200px; margin-right: 10px;"
                                    v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                                    placeholder="Select ..." appendTo="body" @change="handleStatusChange" />
                            </div>
                            <Button label="Add Menus" icon="pi pi-plus" @click="toAddMenus" />
                        </template>
                    </Toolbar>
                    <!-- <Column v-if="data.children && data.children.length > 0" expander style="width: 5rem" /> -->
                    <Column selectionMode="multiple" headerStyle="width: 3rem" />
                    <Column expander style="width: 5rem">
                        <template #body="{ data }">
                            <span v-if="data.children && data.children.length > 0">
                                <Button
                                    :icon="expandedRows.includes(data) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                    class="p-button-text" @click="toggle(data)" />
                            </span>
                        </template>
                    </Column>
                    <!-- Menus Column -->
                    <Column header="Menus" class="p-text-capitalize" headerStyle="width: 45%">
                        <template #body="{ data }">
                            <div class="p-text-capitalize">{{ data.label }}</div>
                        </template>
                    </Column>

                    <!-- Status Column -->
                    <Column header="Status" headerStyle="width: 35%">
                        <template #body="{ data }">
                            <span v-if="data.mbj4 == 1" class="user-badge status-active">Active</span>
                            <span v-if="data.mbj4 == 0" class="user-badge status-temp-suspend">Inactive</span>
                        </template>
                    </Column>

                    <!-- Action Column -->
                    <Column header="Action" headerStyle="width: 25%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editMenusModalOpen(data)" />
                        </template>
                    </Column>

                    <!-- Expansion Template for Submenus -->
                    <template #expansion="slotProps">
                        <div class="p-6">
                            <h5> {{ slotProps.data.label }} Sub menus</h5>
                            <DataTable :value="slotProps.data.children" dataKey="key"
                                v-model:expandedRows="expandedRows">
                                <!-- Expander Column for Submenus -->
                                <Column expander headerStyle="width: 10%">
                                    <template #body="{ data }">
                                        <span v-if="data.sub_children && data.sub_children.length > 0">
                                            <Button
                                                :icon="expandedRows.includes(data) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                                class="p-button-text" @click="toggle(data)" />
                                        </span>
                                    </template>
                                </Column>
                                <Column header="Sr." headerStyle="JustifyContent: center" class="align-center">
                                    <template #body="{ index }">
                                        <span>{{ index + 1 }}</span>
                                    </template>
                                </Column>
                                <Column field="label" header="Sub-menu Name" headerStyle="width: 40%"></Column>
                                <Column field="status" header="Status" headerStyle="width: 30%">
                                    <template #body="{ data }">
                                        <span :class="[
                                            data.mbj4 == 1 ? 'user-badge status-active' : 'user-badge status-temp-suspend'
                                        ]">
                                            {{ data.mbj4 == 1 ? 'Active' : 'Inactive' }}
                                        </span>
                                    </template>
                                </Column>
                                <!-- Sub-expansion for Sub-Children -->
                                <template #expansion="subSlotProps">
                                    <div class="p-6">
                                        <h5>{{ subSlotProps.data.label }} Sub-menus</h5>
                                        <DataTable :value="subSlotProps.data.sub_children" dataKey="key">
                                            <Column headerStyle="width: 5%" class="align-center"></Column>
                                            <Column header="Sr. No" style="width: 10%">
                                                <template #body="{ index }">
                                                    {{ index + 1 }}
                                                </template>
                                            </Column>
                                            <Column header="Sub-menu Name" field="label" headerStyle="width: 50%">
                                            </Column>
                                            <Column header="Status" headerStyle="width: 30%">
                                                <template #body="{ data }">
                                                    <span
                                                        :class="data.mbj4 == 1 ? 'user-badge status-active' : 'user-badge status-temp-suspend'">
                                                        {{ data.mbj4 == 1 ? 'Active' : 'Inactive' }}
                                                    </span>
                                                </template>
                                            </Column>
                                        </DataTable>
                                    </div>
                                </template>
                            </DataTable>
                        </div>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from '../../../service/ApiService';
import useValidate from '@vuelidate/core';

export default {
    data() {
        return {
            expandedRows: [],
            menus: [],
            submenus: [],
            v$: useValidate(),
            isAddReport: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            mainmenus: '',
            menuroute: '',
            submenuroute: '',
            menuUsertype: [],
            menuTypeofuser: [],
            applicationType: 1,
            selectedRows: [],
            adminstatus: null,
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 }
            ]
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        this.loading = true;
        this.getClientMenus();
    },
    methods: {
        handleStatusChange() {
            this.updateMenu();
        },
        getClientMenus() {
            this.ApiService.getClientMenus().then((items) => {
                if (items.status === 200) {
                    this.menus = items.data;
                    this.totalRecords = items.count;
                } else {
                    this.menus = [];
                }
                this.loading = false;
            });
        },
        async toAddMenus() {
            this.$router.push('/listing/menus/add')
        },
        async editMenusModalOpen(menu) {
            this.$router.push({
                path: '/listing/menus/edit/' + menu.key, // Navigate with ID
            });
        },
        toggle(data) {
            if (this.expandedRows.includes(data)) {
                this.expandedRows = this.expandedRows.filter((d) => d !== data);
            } else {
                this.expandedRows = [...this.expandedRows, data];
            }
        },
        async updateMenu() {
            this.isSubmitted = true;
            if (this.v$.$error) return;
            let formData = new FormData();
            const generateMenuIdsMap = (items) => {
                const result = {};
                const traverse = (list) => {
                    for (const item of list) {
                        result[item.key] = {
                            checked: true,
                            partialChecked: false
                        };
                        if (item.children && item.children.length > 0) {
                            traverse(item.children);
                        }
                        if (item.sub_children && item.sub_children.length > 0) {
                            traverse(item.sub_children);
                        }
                    }
                };
                traverse(items);
                return result;
            };
            const selectedTreeValue = generateMenuIdsMap(this.selectedRows);

            formData.append("status", this.adminstatus.value);
            formData.append("menuIds", JSON.stringify(selectedTreeValue));

            this.showLoaderAddBtn = true;
            this.ApiService.multipleUpdateFIRRequestTypes(formData).then((items) => {
                if (items.status === 200) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: items.message,
                        life: 3000,
                    });
                    this.adminstatus = '';
                    this.getClientMenus();
                    this.selectedRows = [];

                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: items.message,
                        life: 3000,
                    });
                }
                this.showLoaderAddBtn = false;
            });
        },
        onPage(event) {
            this.page_no = event.page;
            this.getClientMenus();
        },
        goToDashboard() {
            this.$router.push('/dashboard');
        }

    }
};
</script>